import { UseQueryOptions } from '@tanstack/react-query';
import { WithAccountId } from '@mews-commander/types';

import { Account, AccountResult, GetMultipleAccountParameters, useRepositoryQuery } from '@mews-commander/data-access';

type UseAccountGetQueryParams = Omit<GetMultipleAccountParameters, 'accountIds'> & {
    accountId: string;
};
type QueryOptions = Omit<UseQueryOptions<AccountResult, Error, Account | undefined>, 'select' | 'queryKey'>;

export const useGetAccount = ({ accountId, ...other }: UseAccountGetQueryParams, queryOptions: QueryOptions = {}) =>
    useRepositoryQuery(
        'accounts',
        'getAll',
        { ...other, accountIds: [accountId] },
        {
            ...queryOptions,
            select: ({ accounts }) => (accounts ? accounts.find(({ id }) => id === accountId) : undefined),
        }
    );

export const useGetCustomerOrCompanyAccount = ({ accountId, enabled = true }: WithAccountId & { enabled?: boolean }) =>
    useRepositoryQuery(
        'accounts',
        'getAll',
        { accountIds: [accountId] },
        { select: ({ customers, companies }) => customers?.[0] || companies?.[0], enabled }
    );

export const useGetCompanyAccount = ({ accountId, enabled = true }: WithAccountId & { enabled?: boolean }) =>
    useRepositoryQuery(
        'accounts',
        'getAll',
        { accountIds: [accountId] },
        { select: ({ companies }) => companies?.[0], enabled }
    );
